import $ from 'jquery';
import checkMetamask from './checkMetamask';
import showAlert from './showAlert';

function readCookie(name) {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.indexOf(`${name}=`) === 0) {
      return cookie.substring(name.length + 1);
    }
  }
  return null;
}

export const getToken = () => {
  // get token from cookie
  let token = window.localStorage.getItem('token');
  if (!token) {
    token = readCookie('token');
  }
  return token;
};

export const login = async () => {
  if (!await checkMetamask()) {
    return;
  }

  const accounts = await window.web3.eth.getAccounts();
  const sessionKey = window.sessionStorage.getItem('sessionKey');
  const token = getToken();

  if (sessionKey) {
    await $.post('/api/wallet/session', `session=${sessionKey}&address=${accounts[0]}`, (data) => {
      if (data.success) {
        window.sessionKey = sessionKey;
        window.token = token;
      } else {
        window.sessionStorage.removeItem('sessionKey');
        window.localStorage.removeItem('token');
      }
    });
  }

  if (window.sessionKey) {
    return true;
  }

  const response = await fetch('/api/wallet/nonce', {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'post',
    authorization: true,
    body: JSON.stringify({
      address: accounts[0],
    }),
  }).then(res => res.json());

  const { personal } = window.web3.eth;

  try {
    const signature = await personal.sign(window.web3.utils.toHex(`Sign to Login. Nonce: ${response.nonce}`), accounts[0]);

    const wallet = await fetch('/api/wallet/login', {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'post',
      authorization: true,
      body: JSON.stringify({
        nonce: response.nonce,
        signature,
        address: accounts[0],
      }),
    }).then(res => res.json());

    if (wallet.success) {
      window.localStorage.setItem('token', wallet.token);
      window.sessionStorage.setItem('sessionKey', wallet.session_key);
      window.sessionKey = wallet.session_key;

      if (wallet.code === 'email_not_verified') {
        window.location.href = '/verify-email';
        return false;
      }
      window.location.href = '/game-dashboard';
      return true;
    }

    showAlert({ message: $(wallet.message ? wallet.message : 'Login operation failed, please try again'), icon: 'error' });
  } catch (error) {
    console.log(error.message);
  }

  return false;
};

export default login;
